import { cookieUtils } from '@fishx/utils';
import { set } from 'dot-prop-immutable';
import { PbElement } from "@whalecloud/page-builder-core/utils/types";
import { createElement } from '@whalecloud/page-builder-core/utils/elementUtils';
import { message } from '@whalecloud/fdx';
import { fetch } from '@fishx/rest';
import locales, { languages } from './locale';

// 获取当前国际化
export const getLocale = () => {
  const { getCookie } = cookieUtils;
  let currentLang = getCookie('userLocale');
  if (!languages.includes(currentLang)) {
    currentLang = languages[0];
  }
  return locales[currentLang];
}

// 定义一般组件的target
export const defaultTarget = ['block', 'form', 'row', 'column'];

export const defaultOpts = [
  { label: "Lucy", value: "lucy" },
  { label: "Jack", value: "jack" },
];

export const defaultColumns = [
  {
    key: "0",
    title: 'Name',
    dataIndex: 'name',
  },
  {
    key: "1",
    title: 'Age',
    dataIndex: 'age',
  },
  {
    key: "2",
    title: 'Address',
    dataIndex: 'address',
  }
];

export const defaultDataSource = [
  {
    key: '1',
    name: 'Lucy',
    age: 12,
    address: 'XXXXX',
  },
];

export const treeDataSource = [
  {
    title: 'parent node 1',
    key: '0-0',
    children: [
      {
        title: 'leaf node 1',
        key: '0-0-0',
      },
      {
        title: 'leaf node 2',
        key: '0-0-1',
      },
    ],
  },
];

export const selectCheckboxTreeDataSource = [
  {
    title: 'Node1',
    value: '0-0',
    key: '0-0',
    children: [
      {
        title: 'Child Node1',
        value: '0-0-0',
        key: '0-0-0',
      },
    ],
  },
  {
    title: 'Node2',
    value: '0-1',
    key: '0-1',
    children: [
      {
        title: 'Child Node3',
        value: '0-1-0',
        key: '0-1-0',
      },
      {
        title: 'Child Node4',
        value: '0-1-1',
        key: '0-1-1',
      },
      {
        title: 'Child Node5',
        value: '0-1-2',
        key: '0-1-2',
      },
    ],
  },
];

export const getTypeArr = (messages: Object) => {
  return [
    { name: messages['PAGEBUIDER_SETTINGS_TEXT'], value: 'text' },
    // { name: messages['PAGEBUIDER_SETTINGS_PASSWORD'], value: 'password' },
    // { name: messages['PAGEBUIDER_ELEMENT_TYPE_NUMBER'], value: 'inputNumber' },
    // { name: messages['PAGEBUIDER_ELEMENT_TYPE_TIME'], value: 'timePicker' },
    // { name: messages['PAGEBUIDER_SETTINGS_DATE'], value: 'datePicker' },
    // { name: messages['PAGEBUIDER_SETTINGS_DATE_TIME'], value: 'dateTime' },
    { name: messages['PAGEBUIDER_SETTINGS_EMAIL'], value: 'email' },
    { name: messages['PAGEBUIDER_SETTINGS_URL'], value: 'url' },
    { name: messages['PAGEBUIDER_SETTINGS_TEL'], value: 'tel' },
  ]
}

export const handleInputType = (element, propName, value, parentElement, valueKey, formKey) => {
  const oldObj = element.data.formSettings;
  const keyArr = ['text', 'password', 'email', 'url', 'tel'];
  let newElement = element;
  let getElement;
  
  if (keyArr.includes(value) && element.type === 'input') {
    newElement = set(newElement, propName, value);
  } else if (keyArr.includes(value) && element.type !== 'input') {
    newElement = createElement('input');
    newElement = set(newElement, propName, value);
    getElement = newElement;
    newElement = set(parentElement, 'elements', [newElement]);
  } else if (value === 'dateTime') {
    newElement = createElement('datePicker');
    newElement = set(newElement, `${valueKey}.showTime`, true);
    newElement = set(newElement, `${valueKey}.format`, 'YYYY-MM-DD HH:mm:ss');
    newElement = set(newElement, `${formKey}.name`, oldObj?.name);
    newElement = set(newElement, `${formKey}.label`, oldObj?.label);
    getElement = newElement;
    newElement = set(parentElement, 'elements', [newElement]);
  } else {
    newElement = createElement(value);
    newElement = set(newElement, `${formKey}.name`, oldObj?.name);
    newElement = set(newElement, `${formKey}.label`, oldObj?.label);
    getElement = newElement;
    newElement = set(parentElement, 'elements', [newElement]);
  }
  return {
    newElement,
    getElement,
  }
};

// 计算表格scroll
export const calculateScrollWidth = (formElement, element, len, isEdit, mode) => {
  const prefix = mode === 'render' ? 'render_' : '';
  const { name, labelWidth } = formElement.data.formSettings;
  const tableId = element.data.formSettings.name;
  const tableElement = document.getElementById(`${prefix}${name}_${tableId}`);
  if (!tableElement) return null;

  const formEl = document.getElementById(`${prefix}${name}`);
  const formStyle = window.getComputedStyle(formEl, null);
  const defaultThWidth = 164;
  const lableDefaultPadding = 12;

  const getTableWidth = parseInt(formStyle.width, 10) - lableDefaultPadding - labelWidth;

  tableElement.style.width = 'auto';
  const getDefaultWidth = (!isEdit ? len : (len + 1)) * defaultThWidth;
  let getScrollWidth: number;
  if (getDefaultWidth > getTableWidth) {
    tableElement.style.width = getTableWidth + 'px';
    getScrollWidth = getDefaultWidth;
  } else {
    getScrollWidth = 0;
  }

  return getScrollWidth;
}

export const excludeControls = [
  'letter-spacing',
  'line-height',
  'clear',
  'headings',
  'list-ol',
  'list-ul',
  'remove-styles',
  'superscript',
  'subscript',
  'hr',
  'text-align'
];

export const controls = ['bold', 'italic', 'underline', 'separator', ...excludeControls];

// 富文本校验
export const richEditorRegExp = async (rule, value, userRule) => {
  return new Promise((resolve, reject) => {
    let html = value.toHTML();
    const reg = /^\<p>/gi;
    const reg2 = /\<\/p>$/gi;
    html = html.replace(reg, '');
    html = html.replace(reg2, '');
    const { message, pattern } = userRule;
    if (pattern && (new RegExp(pattern)).test(html)) {
      resolve();
    } else if (!pattern && html !== '') {
      resolve();
    }
    reject(message);
  });
};

// 表格校验
export const tableRegExp = async (rule, value, dataSource = [], userRule) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (dataSource.length > 0) {
        resolve();
      }
      reject(userRule.message);
    }, 100);
  });
}

// popedit校验
export const popEditRegExp = async (rule, values, dataSource, userRule) => {
  return new Promise((resolve, reject) => {
    const { value } = values;
    if (value.length > 0) {
      resolve();
    }
    reject(userRule.message);
  });
}

export const toolFormAttr = {
  size: "small",
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
}

export const toolCollapseAttr = {
  bordered: false,
  expandIconPosition: 'right',
  className: 'formbuild-collapse'
}

export const parseTableColumns = (tableElement: PbElement):Array<object> => {
  const { elements = [] } = tableElement;
  const columns: Array<object> = [];
  elements.forEach((element: PbElement) => {
    if (element.type === 'headerCell') {
      const { columnSettings } = element.data;
      const {required,editType}=columnSettings
      columns.push({
        ...columnSettings,
        ...(required&&editType)?{editRules:[{required}]}:{},
      });
    }
  });
  return columns;
}

export const fetchOptions = async (remote: any = {}) => {
  const messages = getLocale();
  try {
    const { url = '', method = 'GET', params = {} } = remote;
    const { data } = await fetch(url, {
      method,
      data: { ...params },
    });
    if (data) {
      return data;
    } else {
      message.error(messages['PAGEBUIDER_MSG_OPTIONS_REMOTE_FAIL']);
      return [];
    }
  } catch (error) {
    message.error(messages['PAGEBUIDER_MSG_OPTIONS_REMOTE_FAIL']);
    return []
  }
}